import React from 'react';
import { CONNECTOR_TABS, getConnectorTab, type ConnectorTabType } from './connectorTabConfig';
import './ConnectorShell.css';

interface ConnectorTabBarProps {
  activeTab: ConnectorTabType;
  onTabChange: (tab: ConnectorTabType) => void;
}

const ConnectorTabBar: React.FC<ConnectorTabBarProps> = ({ activeTab, onTabChange }) => {
  const active = getConnectorTab(activeTab);

  return (
    <div className="connector-tabbar-wrap">
      <nav className="connector-tabbar" id="connector-tabs" aria-label="Connector sections">
        <div className="connector-tabbar__active-hint" aria-live="polite">
          <span className="connector-tabbar__active-dot" />
          <span className="connector-tabbar__active-label">{active.label}</span>
          <span className="connector-tabbar__active-group">{active.eyebrow}</span>
        </div>

        <div className="connector-tabbar__grid">
          {CONNECTOR_TABS.map((tab) => {
            const isActive = tab.id === activeTab;
            return (
              <button
                key={tab.id}
                id={`${tab.id}-tab`}
                type="button"
                className={`connector-tabbar__tab ${isActive ? 'connector-tabbar__tab--active' : ''}`}
                title={tab.description}
                aria-current={isActive ? 'page' : undefined}
                onClick={() => onTabChange(tab.id)}
              >
                <span className="connector-tabbar__tab-icon">
                  <i className={`fas ${tab.icon}`} aria-hidden="true" />
                </span>
                <span className="connector-tabbar__tab-label">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default ConnectorTabBar;
